<template>
  <button
    v-if="!isLink"
    class="btn"
    :class="{ hollow: hollow, clear: clear }"
    :style="'--btn-clr:' + color"
    :disabled="disabled"
    @click="onClick"
  >
    <slot></slot>
  </button>
  <a
    v-else
    class="btn"
    :class="{ hollow: hollow, clear: clear }"
    :style="'--btn-clr:' + color"
    :href="url"
    :target="linkTarget"
  >
    <slot></slot>
  </a>
</template>

<script>
export default {
  props: {
    onClick: {
      type: Function
    },
    disabled: {
      type: Boolean
    },
    color: {
      type: String,
      default: "var(--clr-blue)"
    },
    hollow: {
      type: Boolean,
      default: false
    },
    clear: {
      type: Boolean,
      default: false
    },
    isLink: {
      type: Boolean,
      default: false
    },
    url: {
      type: String
    },
    linkTarget: {
      type: String,
      default: "_blank"
    }
  }
};
</script>

<style lang="scss" scoped>
.btn {
  display: block;
  padding: var(--spacing-sm) var(--spacing-md);
  width: 100%;

  font-size: var(--fs-16);
  font-weight: var(--fw-medium);
  text-align: center;
  text-decoration: none;

  box-shadow: 0 5px 15px 0 rgba(0, 0, 0, 0.1);
  background: var(--btn-clr);
  color: var(--clr-white);

  border: 1px solid var(--btn-clr);
  border-radius: 1000px;

  transition-property: background, color;
  transition-duration: 250ms;
  transition-timing-function: ease;

  &:hover {
    opacity: 0.9;
  }

  &:focus {
    text-decoration: underline;
  }

  &:disabled {
    opacity: 0.5;
  }
}

.btn.hollow {
  background: var(--clr-white);
  color: var(--btn-clr);
}

.btn.clear {
  background: transparent;
  border-color: transparent;
  box-shadow: none;
  color: var(--btn-clr);
}

@media screen and (min-width: 989px) {
  .btn {
    width: auto;
  }
}
</style>